import React from "react";

import logoHome from "../../../assets/images/logo-home.png";
import avatar1 from "../../../assets/images/Dietplan-updated/67da9fddd372b1b5b44ffef41eed6ceb810ddf8a.jpg";
import avatar2 from "../../../assets/images/Dietplan-updated/d9ddce204792163ce745396135bdc5f320b012d7 (1).jpg";
import avatar3 from "../../../assets/images/Dietplan-updated/30d4a462ea7b6e1428ffcb7ed5d646ca522e5a23.jpg";
import avatar4 from "../../../assets/images/Dietplan-updated/3bbe168eab287460eef89ff5351e750f87e0634b.jpg";

import "./UnlockFeaturesSection.css";

const UnlockFeaturesSection = () => {
  return (
    <div className="diet-unlock">
      <div className="diet-unlock__card" aria-label="Unlock all features">
        <div className="diet-unlock__top">
          <img className="diet-unlock__logo" src={logoHome} alt="Dr Trust 360" loading="lazy" />
          <span className="diet-unlock__pro" aria-hidden="true">
            PRO
          </span>
        </div>

        <div className="diet-unlock__headline">
          Unlock all Features to improve your <span className="diet-unlock__headlineStrong">overall health</span>
        </div>

        <div className="diet-unlock__sub">Find diet plans that suit your health needs</div>

        <div className="diet-unlock__social">
          <div className="diet-unlock__avatars" aria-hidden="true">
            <span className="diet-unlock__avatar">
              <img src={avatar1} alt="" loading="lazy" />
            </span>
            <span className="diet-unlock__avatar">
              <img src={avatar2} alt="" loading="lazy" />
            </span>
            <span className="diet-unlock__avatar">
              <img src={avatar3} alt="" loading="lazy" />
            </span>
            <span className="diet-unlock__avatar">
              <img src={avatar4} alt="" loading="lazy" />
            </span>
          </div>

          <div className="diet-unlock__socialText">&amp; 12447+ more lives transformed</div>
        </div>
      </div>
    </div>
  );
};

export default UnlockFeaturesSection;

